// localStorage 읽기·쓰기 한 곳. 두 벌이 있다:
//   · 삼키는 판(loadJSON·saveJSON·saveText·removeKey·claimOnce) — 시크릿 창·저장소 차단·용량 초과를
//     조용히 넘기고 fallback / false 를 돌려준다.
//   · 던지는 판(getRaw·setRaw·removeRaw) — 부르는 쪽이 자기 try 로 「실패하면 무엇을 돌려줄지」를
//     정하는 자리용. localStorage 를 그대로 부른 것과 똑같이 던진다.

/** 저장된 JSON 을 읽는다. 키가 없으면 null(JSON.parse(null) 과 같다). 저장소·파싱 실패면 fallback. */
export function loadJSON(key, fallback = null) {
  try {
    return JSON.parse(localStorage.getItem(key));
  } catch {
    return fallback;
  }
}

/** 값을 JSON 으로 저장한다. 실패하면 false. */
export function saveJSON(key, value) {
  try {
    localStorage.setItem(key, JSON.stringify(value));
    return true;
  } catch {
    return false;
  }
}

/** 값을 그대로(setItem 이 문자열로 바꾼다) 저장한다. 실패하면 false. */
export function saveText(key, value) {
  try {
    localStorage.setItem(key, value);
    return true;
  } catch {
    return false;
  }
}

/** 키를 지운다. 실패하면 false. */
export function removeKey(key) {
  try {
    localStorage.removeItem(key);
    return true;
  } catch {
    return false;
  }
}

/** 일회성 도장 — 이 기기에서 처음이면 '1' 을 찍고 true. 이미 찍혔거나 저장소를 못 쓰면 false. */
export function claimOnce(flag) {
  try {
    if (localStorage.getItem(flag)) return false;
    localStorage.setItem(flag, '1');
    return true;
  } catch {
    return false;
  }
}

/** localStorage.getItem 그대로 — 던진다. */
export const getRaw = (key) => localStorage.getItem(key);
/** localStorage.setItem 그대로 — 던진다. */
export const setRaw = (key, value) => localStorage.setItem(key, value);
/** localStorage.removeItem 그대로 — 던진다. */
export const removeRaw = (key) => localStorage.removeItem(key);
